class TAppStaticInfoArticle {
  public title: string;
  public content: string;
  public uid?: string | undefined;
  public show_toc: boolean;

  constructor(title: string, content: string, uid?: string | undefined, show_toc: boolean = false) {
    this.title = title;
    this.content = content;
    this.uid = uid;
    this.show_toc = show_toc;
  }
}

export default TAppStaticInfoArticle;
